import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Grid, Cell } from 'formlabs-web-components/Grid';
import { Header } from 'formlabs-web-components/Type';
import { Button } from 'formlabs-web-components/Link';
import TextPlugin from '../../../../common/components/cms/TextPlugin';
import CenterModal from '../../../../common/components/modal/CenterModal';

import './MaterialSelector.module.css';

const Material = ({
  name,
  industryName,
  tags,
  image,
  description,
  elongation,
  hardness,
  link,
  sampleLink
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const handleOpen = e => {
    e.preventDefault();
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <li styleName="material">
      <button onClick={handleOpen}>
        <img alt={name} src={image} />
        <p styleName="material-title">
          {name}
          {industryName && <span styleName="subtitle">{industryName}</span>}
        </p>
        <i className="fl-arrow-right" styleName="blue" />
      </button>
      {open ? (
        <CenterModal
          styleName="somePadding"
          onClose={handleClose}
          width="620px"
        >
          <Grid direction="x" gutters="padding">
            <Cell largeSize={24}>
              <img styleName="modal-image" alt={name} src={image} />
            </Cell>
            <Cell largeSize={24}>
              <Header level={3} displayAs={4}>
                {name}
              </Header>
              <TextPlugin body={description} />
              <Button url={link} arrow="none" color="dark">
                {t('Buy {{material}} Resin Now', {
                  material: name
                })}
              </Button>{' '}
              {sampleLink && (
                <Button
                  styleName="right"
                  url={sampleLink}
                  arrow="none"
                  color="light"
                >
                  {t('Request a Sample')}
                </Button>
              )}
            </Cell>
          </Grid>
        </CenterModal>
      ) : null}
    </li>
  );
};

export default Material;
